// extracted by mini-css-extract-plugin
export default {"row":"SelectablePersonRow_row__-jvAO","checkbox":"SelectablePersonRow_checkbox__TPQiT","completeNameContainer":"SelectablePersonRow_completeNameContainer__lv5BM"};